//===================================
// Root
//===================================

//===================================
// Packages
//===================================

import lazySizes from 'lazysizes';

//===================================
// Styles
//===================================

import '../scss/styles.scss';

//===================================
// Parts
//===================================

import './parts/parts';

//===================================
// Js
//===================================

import './includes/fade-in';
import './includes/tabs';

/**
 * Lazy load images config
 * 
 */
lazySizes.cfg.loadMode = 1;
lazySizes.cfg.expand = 100;

/**
 * Lazy load background images
 * 
 * @param {event} e
 * @returns {null}
 */
const lazyLoadBackgroundImages = (e) => {
  const bg = e.target.getAttribute('data-bg');

  bg ? e.target.style.backgroundImage = `url(${bg})` : null;
}
document.addEventListener('lazybeforeunveil', lazyLoadBackgroundImages);

/**
 * Add class to body on scroll
 * 
 * @returns {null}
 */
const checkScroll = () => {
  document.body.classList.toggle('scrolled', window.scrollY >= 10);
}
document.addEventListener('scroll', checkScroll);
document.addEventListener('DOMContentLoaded', checkScroll);

/**
 * Scroll to element
 * 
 * @param {event} e
 * @returns {null}
 */
const scrollToElement = (e) => {
  e.preventDefault();

  const target = e.currentTarget.getAttribute('data-scroll-to');
  const ele = document.querySelector(target);
  if (!ele) return;

  const y = ele.getBoundingClientRect().top + window.scrollY - 200;
  window.scrollTo({top: y, behavior: 'smooth'});
}
document.addEventListener('DOMContentLoaded', () => {
  const scrollLinks = document.querySelectorAll('[data-scroll-to]');
  scrollLinks.forEach(link => link.addEventListener('click', scrollToElement));
});